import styled from 'styled-components';


export const SMessageSubtitle = styled.h3`
    font-size: 20px;
`;

export const SMessageBody = styled.p`
    font-size: 13px;
`;